import { useEffect } from "react";

const BASE_URL = "https://usdt-to-inr-live.preview.emergentagent.com";

function setMeta(selector, value) {
    const el = document.head.querySelector(selector);
    if (el) el.setAttribute("content", value);
}

export function usePageMeta({ title, description, path }) {
    useEffect(() => {
        const url = `${BASE_URL}${path}`;
        document.title = title;
        setMeta('meta[name="description"]', description);
        setMeta('meta[property="og:title"]', title);
        setMeta('meta[property="og:description"]', description);
        setMeta('meta[property="og:url"]', url);
        setMeta('meta[name="twitter:title"]', title);
        setMeta('meta[name="twitter:description"]', description);
        const canonical = document.head.querySelector('link[rel="canonical"]');
        if (canonical) canonical.setAttribute("href", url);

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: title,
            description,
            url,
            isPartOf: {
                "@type": "WebSite",
                name: "DtOrbit – Best USDT to INR Exchange",
                url: `${BASE_URL}/`,
            },
        });
        document.head.appendChild(script);
        return () => script.remove();
    }, [title, description, path]);
}
